import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submissionContainer", "submissionSelect"];

  connect() {
    this.updateSubmissionVisibility();
  }

  updateSubmissionVisibility() {
    const submissionMode = document.getElementById('mode_submission');
    const bulkMode = document.getElementById('mode_bulk');

    if (bulkMode.checked) {
      this.submissionContainerTarget.style.display = 'none';
      this.submissionSelectTarget.removeAttribute('required');
    } else {
      this.submissionContainerTarget.style.display = 'block';
      this.submissionSelectTarget.setAttribute('required', 'required');
    }
  }
}
